var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var GuiLoggerService = /** @class */ (function () {
    function GuiLoggerService(logger) {
        var _this = this;
        this.logger = logger;
        this.isErrorEnabled = function () { return _this.logger.isErrorEnabled(); };
        this.isWarnEnabled = function () { return _this.logger.isWarnEnabled(); };
        this.isInfoEnabled = function () { return _this.logger.isInfoEnabled(); };
        this.isDebugEnabled = function () { return _this.logger.isDebugEnabled(); };
        this.isLogEnabled = function () { return _this.logger.isLogEnabled(); };
    }
    GuiLoggerService.prototype.error = function (message, optionalParams) {
        this.logger.error(message, optionalParams);
    };
    GuiLoggerService.prototype.warn = function (message, optionalParams) {
        this.logger.warn(message, optionalParams);
    };
    GuiLoggerService.prototype.info = function (message, optionalParams) {
        this.logger.info(message, optionalParams);
    };
    GuiLoggerService.prototype.debug = function (message, optionalParams) {
        this.logger.debug(message, optionalParams);
    };
    GuiLoggerService.prototype.log = function (message, optionalParams) {
        this.logger.error(message, optionalParams);
    };
    GuiLoggerService = __decorate([
        Injectable()
    ], GuiLoggerService);
    return GuiLoggerService;
}());
export { GuiLoggerService };
